import type { ActivationLifecycle } from '@/infra/activation'
import { LifecycleTracker } from '@/infra/lifecycle-tracker'
import { action, observable } from 'mobx'
import type { ReturnAmountsYear } from '@/features/jobs/job-type'
import { ModalViewModel } from '@/infra/ModalViewModel'

/**
 * Modal view model for displaying a tax year's amounts.
 */
export class TaxReturnYearModalViewModel implements ActivationLifecycle {
  private readonly _lifecycle = new LifecycleTracker()

  /**
   * Modal state.
   */
  readonly modal = new ModalViewModel()

  /**
   * The selected tax year.
   */
  @observable accessor taxReturnYear: ReturnAmountsYear | null = null

  @action.bound
  show(returnYear: ReturnAmountsYear) {
    this.taxReturnYear = returnYear
    this.modal.show()
  }

  /** @inheritDoc */
  activate() {
    this._lifecycle.activate()
  }

  /** @inheritDoc */
  deactivate() {
    this._lifecycle.deactivate()
  }
}
